import { JSX } from "react";

import { Box, Typography, useTheme } from "@mui/material";
import DateTimeTextChip from "src/components/DateTimeTextChip/DateTimeTextChip";

function CardHeader({ dateTime, header, children }: { dateTime: string; header: string; children?: JSX.Element | null }): JSX.Element {
  const theme = useTheme();

  return (
    <Box display='flex' justifyContent='space-between' width='100%'>
      <Typography
        color={theme.palette.text.secondary}
        fontSize={theme.fontSizes.sm}
        fontWeight={theme.typography.fontWeightRegular}
        textTransform='uppercase'
      >
        {header}
      </Typography>
      <Box display='flex' alignItems='center' gap={1}>
        <DateTimeTextChip dateTime={dateTime} />
        {children}
      </Box>
    </Box>
  );
}

export default CardHeader;
